const layoutConfig = {
  showSidebar: false,
  showPublicHeader: false,
  showFooter: false,
};

export default layoutConfig; 